<ion-header>
    <ion-toolbar color="darkcyan">
        <ion-grid>
            <ion-row class="ion-align-items-center">
                <ion-col size="auto">
                    <ion-title><a href="/" id="headerTitle">Clickker Watcher</a></ion-title>
                </ion-col>
                <ion-col>
                    <ion-buttons>
                        <ion-button href="/overview">
                            <ion-icon class="headerIconButton" name="book"></ion-icon>
                            {{ "components.header.menuItems.logBooks" | translate }}
                        </ion-button>
                    </ion-buttons>
                </ion-col>
                <ion-col size="auto">
                    <ion-select
                        [value]="languageService.currentLang()"
                        (ionChange)="languageService.setLanguage($event.detail.value)"
                        interface="popover"
                        class="language-selector">
                        @for (lang of languageService.availableLanguages(); track lang.code) {
                            <ion-select-option [value]="lang.code">{{ lang.flag }} {{ lang.code.toUpperCase() }}</ion-select-option>
                        }
                    </ion-select>
                </ion-col>
                <ion-col size="auto">
                    <ion-buttons>
                        <ion-button (click)="navigateToClickkerCloud()">
                            <ion-icon class="headerIconButton" name="arrow-forward"></ion-icon>
                            Clickker Cloud
                        </ion-button>
                    </ion-buttons>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-header>
